<template>
  <div class="page-template">
    <div class="page-title">{{title}}
    </div>
    <div class="page-edit">
      <form-template ref="formTemplate" @submit="submitData">
      </form-template>
    </div>
  </div>
</template>
<script>
  import formTemplate from "@/components/template/formTemplate";
  import api from "@/config/api";

  export default {
    components: {
      formTemplate,
    },
    data() {
      return {
        title: '',
        dialogVisibility: false,
        // 高级搜索条件
        addColumns: {
          formType: 'add',
          labelWidth: "120px",
          span: 12,
          columns: [
            {
              label: "商户id",
              type: "input",
              prop: "id",
              disabled: true
            },
            {
              label: "商户名称",
              type: "input",
              prop: "name",
              disabled: true
            },
            {
              label: "门店数量",
              type: "input",
              prop: "storeNumber",
              disabled: true
            },
            {
              label: "商户号",
              type: "input",
              prop: "merchantNo",
              disabled: true
            },
            {
              label: "商户简称",
              type: "input",
              prop: "shortName",
              rule: [{required: true, message: "请输入商户简称！"}]
            },
            {
              label: "联系人",
              type: "input",
              prop: "contact",
              rule: [{required: true, message: "请输入联系人！"}]
            },
            {
              label: "手机号",
              type: "input",
              prop: "phone",
              maxLength: 11,
              disabled: true,
              // rule: [
              //   {required: true, message: "请输入手机号", trigger: "blur"},
              //   {pattern: this.$utils.reg.phone, message: "请输入正确的手机号", trigger: 'blur'}
              // ],
            },
            {
              label: "商户邮箱",
              type: "input",
              prop: "email",
              rule: [
                {required: true, message: "请输入邮箱", trigger: "blur"},
                {pattern: this.$utils.reg.email, message: "请输入正确的邮箱", trigger: 'blur'}
              ],
            },
            {
              label: "所属行业",
              type: "select",
              prop: "industryCategoryId",
              align: 'center',
              data: [],
              url:api.system.getCategory,
              param: {parentId: 0},
              rule: [{required: true, message: "请选择行业！"}]
            },
            {
              label: "传真",
              type: "input",
              prop: "fax",
              placeholder:'如010-22222222-888',
               rule: [
                {pattern: this.$utils.reg.fax, message: "请输入正确的传真，如010-22222222-888", trigger: 'blur'}
              ],
            },
           {
              label: "公司地址",
              type: "casaderSelect",
              prop: "province",
              span: 24,
              specialRule: [{required: true}],
              casaderOptions: [{
                prop: "province",
                data: [],
                childProps: 'city',
                param: {parentId: 0},
                url: api.getAreaList,
                rule: [{required: true, message: "请选择省！"}]
              }, {
                prop: "city",
                data: [],
                childProps: 'area',
                url: api.getAreaList,
                rule: [{required: true, message: "请选择市！"}]
              }, {
                prop: "area",
                data: [],
                url: api.getAreaList,
                rule: [{required: true, message: "请选择区！"}]
              }]
            },
             {
               span:12,
              label: "详细地址",
              type: "textarea",
              prop: "address",
              rule: [{required: true, message: "请输入详细地址！"}]
            },
            // {
            //   label: "经度",
            //   type: "inputNumber",
            //   prop: "latitude",
            //   disabled:true,
            //   precision:5,
            //   rule: [{required: true, message: "请选择区！"}]
            // },
            // {
            //   label: "纬度",
            //   type: "inputNumber",
            //   prop: "longitude",
            //   disabled:true,
            //   precision:5,
            //   rule: [{required: true, message: "请选择区！"}]
            // },
            // {
            //   label: '',
            //   type: 'map',
            //   prop: 'map',
            //   span: 24,
            //   lat:'latitude',
            //   lon:'longitude',
            //   labelWidth: 120,
            // },
          ],
          formData:{}
        },
        user:{}
      };
    },
    created() {
      this.title = document.title;
      this.user = this.$utils.getSysUser();
      this.getData();
    },
    methods:{
      submitData(formModel){
        this.$axios.fetchPut(api.system.submitMerchant, formModel).then(data => {
            if(data.code == 200){
              this.$notify({
                type: "success",
                title: '修改操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({type: 'success', message: '修改成功!'});
            }else{
              this.$message({type:'error',message:data.msg});
            }
        }).catch((e)=>{
            console.log(e)
          this.$notify({
            type: "error",
            title: '修改操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({type:'error',message:'修改失败'});
        });
      },
      getData(){
        this.$axios.fetchPost(api.system.getMerchant+'?id='+this.user.id, {}).then(data => {
            if(data.code == 200 && data.data){
                this.addColumns.formData = data.data;
                this.$refs['formTemplate'] && this.$refs['formTemplate'].initData(this.addColumns);
            }else{
                 this.$message({type:'error',message:data.msg});
            }
        }).catch((e)=>{
            console.log(e)
            this.$message({type:'error',message:'请求失败'});
        });
      }
    }
  };
</script>




// WEBPACK FOOTER //
// src/page/system/maintain/Merchants.vue